import React from 'react';
import { Button } from 'reactstrap';
import { AFAS_SUB_TABS, getVisibleAfasSubTabs } from '../constants';

const AfasSubTabBar = ({ activeSubTab, onSubTabChange, selectedWeek = '' }) => {
    const tabs = selectedWeek !== undefined && selectedWeek !== null
        ? getVisibleAfasSubTabs(selectedWeek)
        : AFAS_SUB_TABS;

    return (
        <div
            className="afas-sub-tab-bar mb-3"
            role="tablist"
            aria-label="Verzoek detail tabs"
        >
            {tabs.map((tab) => (
                <Button
                    key={tab.key}
                    type="button"
                    color="primary"
                    outline={activeSubTab !== tab.key}
                    className={`afas-sub-tab ${activeSubTab === tab.key ? 'active' : 'btn-outline-secondary'}`}
                    onClick={() => onSubTabChange(tab.key)}
                    role="tab"
                    aria-selected={activeSubTab === tab.key}
                >
                    {tab.label}
                </Button>
            ))}
        </div>
    );
};

export default AfasSubTabBar;